export type IdentityType = "user" | "admin" | "site_owner";

export const identityTypeLabels: Record<IdentityType, string> = {
  user: "Partner user",
  admin: "Admin",
  site_owner: "Site owner",
};

export const identityTypeColors: Record<IdentityType, string> = {
  user: "blue",
  admin: "volcano",
  site_owner: "green",
};

export const identityViewerLabel = "Read-only";
export const identityViewerColor = "gold";
